import React from "react";
import { Grid, Button, Typography } from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import ArrowBackIosNewTwoToneIcon from "@mui/icons-material/ArrowBackIosNewTwoTone";
import { useSelector } from "react-redux";

function ContactusMobile(props) {
  const sessionReducer = useSelector((state) => state.sessionReducer) || {};
  const storeInfo = sessionReducer?.store_details || sessionReducer?.store || {};

  const navigate = useNavigate();

  const storeOrgName = storeInfo?.store_org_name || storeInfo?.store_name || "";
  const storeContact = storeInfo?.store_contact_no || storeInfo?.store_phone || "";
  const storeEmail = storeInfo?.email_id || storeInfo?.store_email || "";
  
  const addressParts = [
    storeInfo?.store_ad1,
    storeInfo?.store_ad2,
    storeInfo?.store_city,
    storeInfo?.store_country,
    storeInfo?.store_zip
  ].filter(Boolean);
  const storeAddress = addressParts.join(", ");

  return (
    <Grid style={{ background: "#f1f1f1", height: "100vh" }}>
      <Grid
        style={{
          padding: "0.8rem",
          boxShadow: "0px 0px 9px",
          background: "white",
          textAlign: "center",
          position: "relative"
        }}
      >
        <Button
          onClick={() => {
            navigate("/");
          }}
          style={{
            position: "absolute",
            left: 0,
            top: "50%",
            transform: "translateY(-50%)"
          }}
        >
          <ArrowBackIosNewTwoToneIcon />
        </Button>
        <Typography variant="h5" style={{ fontWeight: "bold" }}>
          Contact Us
        </Typography>
      </Grid>
      <Grid style={{ marginTop: "3rem", padding: "1rem" }}>
        <Typography><span style={{ textTransform: "uppercase", fontWeight: "bold" }}>{storeOrgName}</span></Typography>

        <Typography style={{ padding: "0.5rem 0" }}>Contact Number: {storeContact ? `+91 ${storeContact}` : "N/A"}</Typography>

        <Typography style={{ padding: "0.5rem 0" }}>E-mail ID: {storeEmail || "N/A"}</Typography>
        <Typography style={{ padding: "0.5rem 0" }}>Address: {storeAddress || "N/A"}</Typography>
      </Grid>
    </Grid>
  );
}

export default ContactusMobile;